import React from 'react';
import { useLocation } from 'react-router-dom';

import Section from '@hero/ui-kit/layout/Section';
import { WhiteSpaceSize } from '@hero/ui-kit/types';
import { SearchProps } from '../SearchForm';
import Header, { HeaderProps } from './Header';
import { segmentPage } from '../../utils/segment';

type Props = HeaderProps & {
    children: React.ReactNode;
    paddingHorizontal?: WhiteSpaceSize;
} & SearchProps;

const Layout: React.FC<Props> = ({ children, paddingHorizontal = 'regular', ...props }) => {
    const location = useLocation();
    React.useEffect(() => segmentPage, [location]);

    return (
        <>
            <Header {...props} />
            <Section paddingHorizontal={paddingHorizontal} paddingTop="none">
                {children}
            </Section>
        </>
    );
};

export default Layout;
